import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faPaperPlane, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FormHandler, Textarea } from 'Components/Form';
import { Card, CardBody } from 'Components/Card';
import ChatMessage from './ChatMessage';
import { Toast, Socket, User } from 'Services';
import { translation } from 'Services/TranslationHelpers';
import ChatApi from 'Services/Api/MainStage/Chat';
import { getFallbackAvatarUrl } from 'Services/AuthHelpers';

class MainStageChatStandAlone extends React.Component {
    containerRef = null;
    titleRef = null;
    formRef = null;

    state = {
        working: false,
        messages: [],
        meta: null,
    };

    componentDidMount = () => {
        this.fetchMessages();
        this.containerRef.addEventListener('scroll', this.handleLoadMore);

        Socket.getConnection()
            .private(`main_stage_chat.${this.props.sessionId}`)
            .listen('MainStageChat', (e) => {
                if (e.message.main_stage_chat_id === null) {
                    this.handleAddMessage(e.message);
                }
            })
            .listen('MainStageChatDeleted', (e) => this.handleDeleteMessage(e.message))
            .listen('subscription_error', console.error);

        // if (window.base.main_stage.layout === 'tabs') {
            this.setSize();
        // }
    };

    componentDidUpdate = (prevProps) => {
        if (window.base.main_stage.layout === 'tabs' && prevProps.height !== this.props.height) {
            this.setSize();
        }
    };

    componentWillUnmount = () => {
        this.containerRef.removeEventListener('scroll', this.handleLoadMore);
        Socket.getConnection().leave(`main_stage_chat.${this.props.sessionId}`);
    };

    setSize = () => {
//        this.containerRef.style.height = `${window.innerHeight - this.formRef.clientHeight - this.titleRef.clientHeight - 96 - 240}px`;
    };

    fetchMessages = async () => {
        if (this.state.working || (this.state.meta !== null && this.state.meta?.current_page === this.state.meta?.last_page)) {
            return;
        }

        this.setState({ working: true });

        const request = await ChatApi.get({
            session: this.props.sessionId,
        }, {
            page: (this.state.meta?.current_page ?? 0) + 1,
        });

        if (request.success) {
            return this.setState({
                messages: [...this.state.messages, ...request.data.data],
                meta: request.data.meta,
                working: false,
            });
        }

        Toast.error();
    };

    handleAddMessage = (message) => {
        const i = this.state.messages.map(m => m.id).indexOf(message.id);

        if (i === -1) {
            this.setState({
                messages: [
                    ...[message],
                    ...this.state.messages,
                ],
            });
        }
    };

    handleDeleteMessage = (message) => {
        this.setState({
            messages: this.state.messages.filter(m => m.id !== message.id),
        });
    };

    handleLoadMore = (e) => {
        const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop) === e.target.clientHeight;

        if (bottom) {
            this.fetchMessages();
        }
    };

    handlePostMessage = (data) => {
        return ChatApi.post({
            session: this.props.sessionId
        }, {
            ...data,
            session_id: this.props.sessionId
        });
    };

    getAvatarUrl = (user) => {
        return user.avatar_path && user.avatar_path.url ? user.avatar_path.url : getFallbackAvatarUrl(user);
    };

    render() {
        const { messages, working } = this.state;
        const { bgColour = 'bg-app-gray', restrictWidth = true, heightClass = 'max-h-[70-svh] md:max-h-[40em]', readOnly = false } = this.props;

        return (
            <Card className={`h-full ${bgColour} text-app-blue rounded-xl rounder-b-none max-w-2xl mx-auto`} bgColour="bg-app-blue" titleColor="text-white">
            <CardBody className="h-full flex flex-grow flex-col">
                <div className="flex justify-between items-center mb-4">
                    <h1
                        className="text-2xl font-semibold text-center text-app-agenda-lighter-blue"
                        ref={ ref => this.titleRef = ref }
                    >
                        Chat
                    </h1>
                    <div className="flex space-x-2">
                        <div className="flex flex-col items-center text-xs">
                            <div className="w-4 h-4 bg-app-light-blue"></div>
                            <span>Virtual</span>
                        </div>
                        <div className="flex flex-col items-center text-xs">
                            <div className="w-4 h-4 bg-app-blue"></div>
                            <span>In Person</span>
                        </div>
                    </div>
                </div>
                <div
                    className={ `h-full w-full max-w-2l mx-auto py-2 ${ window.base.main_stage.layout === 'tabs' ? '' : 'h-full' }` }
                    ref={ ref => this.containerRef = ref }
                >
                { messages.map ( ( message, i ) => {
                    const user_message_group = message.user.first_group_name ?? '';

                    let virtual_group = user_message_group.includes ( 'virtual' );

                    return <div
                        key={ message.id }
                        className={ `mb-2 p-5 flex ${ i % 2 === 0 ? 'flex-row' : 'flex-row-reverse' } items-end` }
                    >
                        { window.base.features.avatar && (
                            <img
                                className={ `rounded-full h-8 w-8 ${ i % 2 === 0 ? 'mr-2' : 'ml-2' }` }
                                src={ this.getAvatarUrl ( message.user ) }
                                alt={ message.user?.full_name }
                            />
                        ) }
                        <div className={ `${ virtual_group ? 'bg-app-light-blue' : 'bg-app-blue' } flex flex-col text-white rounded-xl p-3 relative` }>
                            <div className="flex justify-between text-xs">
                                <span>{ message.user.first_name } { message.user.last_name }</span>
                            </div>
                            <div className="text-md mb-1 leading-5">
                                { message.message.split ( '\n' ).map ( ( item, key ) => (
                                    <p
                                        className="mb-1"
                                        key={ key }
                                    >
                                        { item }
                                    </p>
                                ) ) }
                            </div>
                            { User.data.is_admin && !readOnly && (
                                <div className="ml-auto flex items-center text-xs">
                                    <button onClick={ () => this.handleDeleteMessage ( message ) }>
                                        <FontAwesomeIcon icon={ faTrash } />
                                    </button>
                                </div>
                            ) }
                            <div className={ `absolute bottom-0 ${ i % 2 === 0 ? 'left-0 border-l-8 border-l-app-light-blue border-r-8 border-r-transparent' : 'right-0 border-r-8 border-r-app-light-blue border-l-8 border-l-transparent' } w-0 h-0 border-t-8 border-t-transparent` }></div>
                        </div>
                    </div>
                } ) }
                </div>
            </CardBody>
        </Card>
        );
    }

    renderNewMessageForm = () => {
        const { form, working, handleInput, handleSubmit } = this.props;

        return (
            <div
                className="relative w-full mt-2"
                ref={ ref => this.formRef = ref }
            >
                <Textarea
                    rows={ 3 }
                    value={ form.message ?? '' }
                    onChange={ ( v ) => handleInput ( 'message', v ) }
                    placeholder={ translation ( 'misc', 'type_here' ) }
                    emojiPicker={true}
                    className="text-app-blue"
                />
                <FontAwesomeIcon
                    icon={faPaperPlane}
                    size="1x"
                    onClick={() => !working && form.message ? handleSubmit(
                        null,
                        this.handlePostMessage,
                        (message) => this.handleAddMessage(message.data.data),
                        true,
                    ) : false}
                    className="absolute top-12 right-6 text-black cursor-pointer"
                />
            </div>
        );
    };
}

export default FormHandler(MainStageChatStandAlone);
